export const logo = require('../assets/images/logo192.png')
